import { httpClient2 } from "modules/core/utils/httpClient2";

import { UserFeatureModuleKey } from "modules/user/types/entities";

export const addAccountFeatureModule = async (key: UserFeatureModuleKey) => {
  const response = await httpClient2.post(
    "/feature_module_accesses/add_module",
    undefined,
    {
      params: {
        key
      }
    }
  );

  return response.data;
};

export const deleteAccountFeatureModule = async (key: UserFeatureModuleKey) => {
  const response = await httpClient2.put(
    "/feature_module_accesses/remove_module",
    undefined,
    {
      params: {
        key
      }
    }
  );

  return response.data;
};
